module.exports = __webpack_public_path__ + "img/big-icon-heart.a81a5123.svg";